/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const ArrowLeft3 = ({ className }) => {
  return (
    <svg
      className={`arrow-left-3 ${className}`}
      fill="none"
      height="19"
      viewBox="0 0 18 19"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M0.899902 9.5H17.0999"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />

      <path
        className="path"
        d="M7.23903 3.16089L0.899902 9.50002L7.23903 15.8392"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
    </svg>
  );
};
